/// <amd-module name="TFS/Mobile/Components/SwitchToMobile" />
import * as React from "react";

import { VssComponent } from "VSS/Platform/Layout";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { deleteCookie } from "VSS/Platform/Util/Cookie";

import { Icon } from "VSSUI/Icon";
import { Button } from "VSSUI/Button";

import { ISwitchToMobileProps } from "TFS/Mobile/Components/SwitchToMobile.Props";
import * as MobileResources from "TFS/Mobile/Resources";

class SwitchToMobile extends VssComponent<ISwitchToMobileProps, {}> {
    public static componentType = "ms.vss-tfs-web.switchToMobileCommand";

    public render(): JSX.Element {
        const { ariaLabel, text = MobileResources.MobileBannerMessage } = this.props;
        return (
            <div className="switch-to-mobile flex flex-noshrink flex-center justify-center">
                <Button ariaLabel={ariaLabel} className="flex-grow switch-to-mobile-button" onClick={this.onClick} primary={true}>
                    <Icon iconName="Globe" />
                    <span className="switch-to-mobile-text">{text}</span>
                </Button>
            </div>
        );
    }

    private onClick = () => {
        const telemetryService = this.context.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        telemetryService.publishEvent("MobileNavigation", "SwitchToMobile", { newMobileSupport: true });

        deleteCookie("VstsBypassMobile");
        // @ts-ignore TypeScript 4.4 upgrade
        window.location.reload(true);
    };
}

VssComponent.register(SwitchToMobile.componentType, SwitchToMobile);
